import {storeFood} from "./StoreFood";
import {ProductService} from "./ProductService";
import {updateFood} from "./UpdateFood";
import {productFactory} from "../factory/product.factory";
import uuid from "uuid4";
import {multiPortionFoodsManager} from "./MultiPortionFoodsManager";
import {store} from "../store/store";
import axios from "axios";

export const FoodService = {
    async storeFood(food) {
        const result = await storeFood(food);
        this.replaceProducts(result, food);
        food.externalId = result.externalId;
        return food;
    },

    async updateFood(food) {
        const result = await updateFood(food);
        this.replaceProducts(result, food);
        return food;
    },

    replaceProducts(result, food) {
        for (const [oldProductExternalId, newProductExternalId] of Object.entries(result.createdOrReplacedProducts)) {
            ProductService.replaceProductByExternalIdInSchema(oldProductExternalId, newProductExternalId);
            food.findProductsBy(oldProductExternalId, 'externalId')
                .forEach((foodProductToReplace) => {
                    let productReplacement = productFactory.create(
                        uuid(),
                        newProductExternalId,
                        foodProductToReplace.name,
                        foodProductToReplace.weight,
                        foodProductToReplace.energy.amount,
                        foodProductToReplace.category,
                        foodProductToReplace.allergen,
                        foodProductToReplace.disliked,
                        foodProductToReplace.nutrients,
                        foodProductToReplace.portion,
                    );
                    food.replaceProduct(foodProductToReplace.id, productReplacement);
                    if (food.isMultiPortionFood()) {
                        multiPortionFoodsManager.updateMultiPortionFood(food, store.state.menu.schema);
                    }
                });
        }
    },

    async fetchOwnFoodsCount() {
        const {data} = await axios.get(`/v2/foods/own/count`);
        return data.count;
    }
};